import { flatten } from "lodash";
import { CreditReport, CreditScore, Tradeline } from "../types/api";

export const getTradelines = (creditReports: CreditReport[] | null): Tradeline[] => {
  return (
    flatten(creditReports ? creditReports.map(cr => cr.tradelines) : [])
      // ensure that there are no errant nulls in the flattened tradelines array
      .filter(tr => tr != null)
  );
};

export const getOpenRealEstateTradelines = (creditReports: CreditReport[] | null): Tradeline[] => {
  return getTradelines(creditReports).filter(
    tr => tr.is_real_estate && tr.account_status.toLowerCase() === "open",
  );
};

export const getRealEstateTradelines = (creditReports: CreditReport[] | null): Tradeline[] => {
  return getTradelines(creditReports).filter(t => t.is_real_estate);
};

export const getBlockedOnOperator = (creditReports: CreditReport[]): CreditReport[] => {
  return creditReports ? creditReports.filter(cr => cr.blocked_on_operator === true) : [];
};

export const getFrozen = (creditReports: CreditReport[]): CreditReport[] => {
  return creditReports ? creditReports.filter(cr => cr.frozen === true) : [];
};

export const getBorrowerNamesAsCsv = (creditReport: CreditReport): string => {
  let borrowerNames = [creditReport.borrower1_name];
  if (creditReport.borrower2_name) {
    borrowerNames = [...borrowerNames, creditReport.borrower2_name];
  }
  return borrowerNames.join(", ");
};

export const getCreditScores = (creditReports: CreditReport[] | null): CreditScore[] => {
  return flatten(creditReports ? creditReports.map(cr => cr.credit_scores) : []);
};
